import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './core/services/local-storage.service';
import { UsuariosService } from './core/services/usuarios.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGOUT = environment.URL_LOGOUT;
    URL_LOGIN = environment.URL_LOGIN;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: ['admin'],
            itens: [
                {
                    label: 'Centro de Custo',
                    icone: 'copyright',
                    link: '/centrosdecusto',
                    roles: ['admin']
                }
            ]
        },
        {
            label: 'Segurança',
            roles: ['admin'],
            itens: [
                {
                    label: 'Aplicações',
                    icone: 'apps',
                    link: '/seguranca/aplicacoes',
                    roles: ['admin']
                },
                {
                    label: 'Grupos',
                    icone: 'table_view',
                    link: '/seguranca/grupos',
                    roles: ['admin']
                },
                {
                    label: 'Usuarios',
                    icone: 'people',
                    link: '/seguranca/usuarios',
                    roles: ['admin']
                },
                {
                    label: 'Workflow',
                    icone: 'engineering',
                    link: '/seguranca/workflow',
                    roles: ['admin']
                },
                {
                    label: 'User AD',
                    icone: 'badge',
                    link: '/seguranca/userad',
                    roles: ['admin']
                },
                {
                    label: 'Controle de Acesso',
                    icone: 'login',
                    link: '/seguranca/controleacesso',
                    roles: ['admin']
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoes: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService,
        private _usuario: UsuariosService
    ) {}

    ngOnInit() {
        const decoded = this._usuario.decodeToken();
        if (decoded && this._usuario.checkIsUserAdminCore()) {
            this._permissoes.registrarPermissoes(['admin']);
        } else {
            window.open(this.URL_LOGOUT, '_self');
        }
    }

    async logout(event: boolean) {
        if (event) {
            try {
                //TODO: LOGOUT POR API FICARÁ PARA OUTRA FASE
                // await this._usuario.logout();
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete(environment.ACCESS_TOKEN, '/', domain);
        this._cookie.delete(environment.REFRESH_TOKEN, '/', domain);
    }
}
